import { motion, useScroll, useTransform } from "framer-motion";

// Fixed atmospheric background: matte base, ambient light blobs, film grain.
export const Background = () => {
  const { scrollYProgress } = useScroll();
  const hueShift = useTransform(scrollYProgress, [0, 1], [0, 18]);

  return (
    <>
      <div
        className="fixed inset-0 z-0"
        style={{
          background:
            "radial-gradient(90% 60% at 50% 22%, rgba(217,164,65,0.05) 0%, transparent 60%)",
        }}
        aria-hidden="true"
      />
      <motion.div style={{ y: hueShift }} aria-hidden="true">
        <div className="ambient-blob ambient-1" />
        <div className="ambient-blob ambient-2" />
        <div className="ambient-blob ambient-3" />
      </motion.div>
      {/* subtle vignette for editorial depth */}
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(120% 90% at 50% 8%, transparent 45%, rgba(15,11,9,0.5) 100%)",
        }}
        aria-hidden="true"
      />
      <div className="grain-overlay" aria-hidden="true" />
    </>
  );
};

export default Background;
